module.exports = __webpack_public_path__ + "img/65_photo.7b6ac1e7.png";